import React from 'react';

import type { ItemContent } from '../../../../content/dontgiftguide/types';
import { LevelThreeContentType } from '../../../../content/dontgiftguide/types';
import type { ExtraSmallProductTileProps } from '../../items/ExtraSmallProductTile/ExtraSmallProductTile';
import { ExtraSmallProductTile } from '../../items/ExtraSmallProductTile/ExtraSmallProductTile';
import type { LargeProductTileProps } from '../../items/LargeProductTile/LargeProductTile';
import { LargeProductTile } from '../../items/LargeProductTile/LargeProductTile';
import { SectionCopy } from '../../items/SectionCopy/SectionCopy';
import { SectionTitle } from '../../items/SectionTitle/SectionTitle';
import type { SmallProductTileProps } from '../../items/SmallProductTile/SmallProductTile';
import { SmallProductTile } from '../../items/SmallProductTile/SmallProductTile';
import type { WideProductTileProps } from '../../items/WideProductTile/WideProductTile';
import { WideProductTile } from '../../items/WideProductTile/WideProductTile';
import { Content } from '../../molecules/Content/Content';
import * as styles from './ItemsSection.styles';

export interface ItemsSectionProps {
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  items: ItemContent[];
  darkCopyColor?: boolean;
}

export const ItemsSection = (props: ItemsSectionProps) => {
  const { onLinkClick, items, darkCopyColor = false } = props;

  return (
    <Content darkCopyColor={darkCopyColor}>
      {items.map((item) => {
        const { contentType, ...itemProps } = item;
        const key = itemProps.productCode || itemProps.copy;

        switch (contentType) {
          case LevelThreeContentType.Heading:
            return <SectionTitle key={key} copy={itemProps.copy!} />;
          case LevelThreeContentType.Copy:
            return <SectionCopy key={key} copy={itemProps.copy!} />;
          case LevelThreeContentType.LargeTile:
            return (
              <LargeProductTile
                key={key}
                {...(itemProps as LargeProductTileProps)}
                onLinkClick={onLinkClick}
              />
            );
          case LevelThreeContentType.WideTile:
            return (
              <WideProductTile
                key={key}
                {...(itemProps as WideProductTileProps)}
                onLinkClick={onLinkClick}
              />
            );
          case LevelThreeContentType.SmallTile:
            return (
              <div key={key} css={styles.halfWidth}>
                <SmallProductTile
                  {...(itemProps as SmallProductTileProps)}
                  onLinkClick={onLinkClick}
                />
              </div>
            );
          case LevelThreeContentType.ExtraSmallTile:
            return (
              <div key={key} css={styles.thirdWidth}>
                <ExtraSmallProductTile {...(itemProps as ExtraSmallProductTileProps)} />
              </div>
            );
          default:
            return null;
        }
      })}
    </Content>
  );
};
